<template>
  <div>
    <!-- CRMAgentDialogs -->
    <div v-for="CRMAgentStickerDialog in navigation.CRMAgentStickerDialog" :key="CRMAgentStickerDialog.dialogID">
      <CRMAgentStickerDialog
        :ref="`CRMAgentStickerDialog_${CRMAgentStickerDialog.dialogID}`"
        @closeCRMAgentStickerDialog="closeDialog('CRMAgentStickerDialog', CRMAgentStickerDialog.dialogID)"
      />
    </div>


    <div v-for="CRMWhatsappContactDialog in navigation.CRMWhatsappContactDialog" :key="CRMWhatsappContactDialog.dialogID">
      <CRMWhatsappContactDialog
        :ref="`CRMWhatsappContactDialog_${CRMWhatsappContactDialog.dialogID}`"
        @closeCRMWhatsappContactDialog="closeDialog('CRMWhatsappContactDialog', CRMWhatsappContactDialog.dialogID)"
      />
    </div>
    <div v-for="CRMWhatsappContactLocationDialog in navigation.CRMWhatsappContactLocationDialog" :key="CRMWhatsappContactLocationDialog.dialogID">
      <CRMWhatsappContactLocationDialog
        :ref="`CRMWhatsappContactLocationDialog_${CRMWhatsappContactLocationDialog.dialogID}`"
        @closeCRMWhatsappContactLocationDialog="closeDialog('CRMWhatsappContactLocationDialog', CRMWhatsappContactLocationDialog.dialogID)"
      />
    </div>


    <div v-for="CRMWhatsappInvoiceDialog in navigation.CRMWhatsappInvoiceDialog" :key="CRMWhatsappInvoiceDialog.dialogID">
      <CRMWhatsappInvoiceDialog
        :ref="`CRMWhatsappInvoiceDialog_${CRMWhatsappInvoiceDialog.dialogID}`"
        @closeCRMWhatsappInvoiceDialog="closeDialog('CRMWhatsappInvoiceDialog', CRMWhatsappInvoiceDialog.dialogID)"
      />
    </div>
    <div v-for="CRMWhatsappInvoicesDialog in navigation.CRMWhatsappInvoicesDialog" :key="CRMWhatsappInvoicesDialog.dialogID">
      <CRMWhatsappInvoicesDialog
        :ref="`CRMWhatsappInvoicesDialog_${CRMWhatsappInvoicesDialog.dialogID}`"
        @closeCRMWhatsappInvoicesDialog="closeDialog('CRMWhatsappInvoicesDialog', CRMWhatsappInvoicesDialog.dialogID)"
      />
    </div>






    <div v-for="MediaDialog in navigation.MediaDialog" :key="MediaDialog.dialogID">
      <MediaDialog
        :ref="`MediaDialog_${MediaDialog.dialogID}`"
        @closeMediaDialog="closeDialog('MediaDialog', MediaDialog.dialogID)"
      />
    </div>

    <div v-for="CRMShutdownDialog in navigation.CRMShutdownDialog" :key="CRMShutdownDialog.dialogID">
      <CRMShutdownDialog
        :ref="`CRMShutdownDialog_${CRMShutdownDialog.dialogID}`"
        @closeCRMShutdownDialog="closeDialog('CRMShutdownDialog', CRMShutdownDialog.dialogID)"
      />
    </div>




    <div v-for="CRMWhatsappContactLatitudeLongitudeLocationDialog in navigation.CRMWhatsappContactLatitudeLongitudeLocationDialog" :key="CRMWhatsappContactLatitudeLongitudeLocationDialog.dialogID">
      <CRMWhatsappContactLatitudeLongitudeLocationDialog
        :ref="`CRMWhatsappContactLatitudeLongitudeLocationDialog_${CRMWhatsappContactLatitudeLongitudeLocationDialog.dialogID}`"
        @closeCRMWhatsappContactLatitudeLongitudeLocationDialog="closeDialog('CRMWhatsappContactLatitudeLongitudeLocationDialog', CRMWhatsappContactLatitudeLongitudeLocationDialog.dialogID)"
      />
    </div>
    <div v-for="CRMWhatsappContactURLLocationDialog in navigation.CRMWhatsappContactURLLocationDialog" :key="CRMWhatsappContactURLLocationDialog.dialogID">
      <CRMWhatsappContactURLLocationDialog
        :ref="`CRMWhatsappContactURLLocationDialog_${CRMWhatsappContactURLLocationDialog.dialogID}`"
        @closeCRMWhatsappContactURLLocationDialog="closeDialog('CRMWhatsappContactURLLocationDialog', CRMWhatsappContactURLLocationDialog.dialogID)"
      />
    </div>
    <div v-for="CRMWhatsappContactAddressDialog in navigation.CRMWhatsappContactAddressDialog" :key="CRMWhatsappContactAddressDialog.dialogID">
      <CRMWhatsappContactAddressDialog
        :ref="`CRMWhatsappContactAddressDialog_${CRMWhatsappContactAddressDialog.dialogID}`"
        @closeCRMWhatsappContactAddressDialog="closeDialog('CRMWhatsappContactAddressDialog', CRMWhatsappContactAddressDialog.dialogID)"
      />
    </div>

    
    <div v-for="CRMWhatsappMarketingCampaignDialog in navigation.CRMWhatsappMarketingCampaignDialog" :key="CRMWhatsappMarketingCampaignDialog.dialogID">
      <CRMWhatsappMarketingCampaignDialog 
        :ref="`CRMWhatsappMarketingCampaignDialog_${CRMWhatsappMarketingCampaignDialog.dialogID}`"
        @closeCRMWhatsappMarketingCampaignDialog="closeDialog('CRMWhatsappMarketingCampaignDialog', CRMWhatsappMarketingCampaignDialog.dialogID)"
      />
    </div>
    <div v-for="CRMWhatsappMediaCatalogDialog in navigation.CRMWhatsappMediaCatalogDialog" :key="CRMWhatsappMediaCatalogDialog.dialogID">
      <CRMWhatsappMediaCatalogDialog 
        :ref="`CRMWhatsappMediaCatalogDialog_${CRMWhatsappMediaCatalogDialog.dialogID}`"
        @closeCRMWhatsappMediaCatalogDialog="closeDialog('CRMWhatsappMediaCatalogDialog', CRMWhatsappMediaCatalogDialog.dialogID)"
      />
    </div>
    <div v-for="CRMWhatsappMediaCatalogMediaDialog in navigation.CRMWhatsappMediaCatalogMediaDialog" :key="CRMWhatsappMediaCatalogMediaDialog.dialogID">
      <CRMWhatsappMediaCatalogMediaDialog 
        :ref="`CRMWhatsappMediaCatalogMediaDialog_${CRMWhatsappMediaCatalogMediaDialog.dialogID}`"
        @closeCRMWhatsappMediaCatalogMediaDialog="closeDialog('CRMWhatsappMediaCatalogMediaDialog', CRMWhatsappMediaCatalogMediaDialog.dialogID)"
      />
    </div>
    <div v-for="CRMWhatsappConversationDialog in navigation.CRMWhatsappConversationDialog" :key="CRMWhatsappConversationDialog.dialogID">
      <CRMWhatsappConversationDialog 
        :ref="`CRMWhatsappConversationDialog_${CRMWhatsappConversationDialog.dialogID}`"
        @closeCRMWhatsappConversationDialog="closeDialog('CRMWhatsappConversationDialog', CRMWhatsappConversationDialog.dialogID)"
      />
    </div>

    
    <div v-for="insertCRMWhatsappConversationDialog in navigation.insertCRMWhatsappConversationDialog" :key="insertCRMWhatsappConversationDialog.dialogID">
      <insertCRMWhatsappConversationDialog
        :ref="`insertCRMWhatsappConversationDialog_${insertCRMWhatsappConversationDialog.dialogID}`"
        @closeInsertCRMWhatsappConversationDialog="closeDialog('insertCRMWhatsappConversationDialog', insertCRMWhatsappConversationDialog.dialogID)"
      ></insertCRMWhatsappConversationDialog>
    </div>
    <div v-for="closeCRMWhatsappConversationDialog in navigation.closeCRMWhatsappConversationDialog" :key="closeCRMWhatsappConversationDialog.dialogID">
      <closeCRMWhatsappConversationDialog
        :ref="`closeCRMWhatsappConversationDialog_${closeCRMWhatsappConversationDialog.dialogID}`"
        @closeCRMWhatsappConversationDialog="closeDialog('closeCRMWhatsappConversationDialog', closeCRMWhatsappConversationDialog.dialogID)"
      ></closeCRMWhatsappConversationDialog>
    </div>
    <div v-for="rejectCRMWhatsappConversationDialog in navigation.rejectCRMWhatsappConversationDialog" :key="rejectCRMWhatsappConversationDialog.dialogID">
      <rejectCRMWhatsappConversationDialog
        :ref="`rejectCRMWhatsappConversationDialog_${rejectCRMWhatsappConversationDialog.dialogID}`"
        @closeCRMWhatsappConversationDialog="closeDialog('rejectCRMWhatsappConversationDialog', rejectCRMWhatsappConversationDialog.dialogID)"
      ></rejectCRMWhatsappConversationDialog>
    </div>
    <div v-for="sendCRMWhatsappMessageToCRMWhatsappContactDialog in navigation.sendCRMWhatsappMessageToCRMWhatsappContactDialog" :key="sendCRMWhatsappMessageToCRMWhatsappContactDialog.dialogID">
      <sendCRMWhatsappMessageToCRMWhatsappContactDialog
        :ref="`sendCRMWhatsappMessageToCRMWhatsappContactDialog_${sendCRMWhatsappMessageToCRMWhatsappContactDialog.dialogID}`"
        @closeSendCRMWhatsappMessageToCRMWhatsappContactDialog="closeDialog('sendCRMWhatsappMessageToCRMWhatsappContactDialog', sendCRMWhatsappMessageToCRMWhatsappContactDialog.dialogID)"
      ></sendCRMWhatsappMessageToCRMWhatsappContactDialog>
    </div>
    <div v-for="CRMWhatsappConversationNoteDialog in navigation.CRMWhatsappConversationNoteDialog" :key="CRMWhatsappConversationNoteDialog.dialogID">
      <CRMWhatsappConversationNoteDialog
        :ref="`CRMWhatsappConversationNoteDialog_${CRMWhatsappConversationNoteDialog.dialogID}`"
        @closeCRMWhatsappConversationNoteDialog="closeDialog('CRMWhatsappConversationNoteDialog', CRMWhatsappConversationNoteDialog.dialogID)"
      ></CRMWhatsappConversationNoteDialog>
    </div>
    <div v-for="CRMWhatsappContactFilesDialog in navigation.CRMWhatsappContactFilesDialog" :key="CRMWhatsappContactFilesDialog.dialogID">
      <CRMWhatsappContactFilesDialog
        :ref="`CRMWhatsappContactFilesDialog_${CRMWhatsappContactFilesDialog.dialogID}`"
        @closeCRMWhatsappContactFilesDialog="closeDialog('CRMWhatsappContactFilesDialog', CRMWhatsappContactFilesDialog.dialogID)"
      ></CRMWhatsappContactFilesDialog>
    </div>
    <div v-for="CRMWhatsappContactFileDialog in navigation.CRMWhatsappContactFileDialog" :key="CRMWhatsappContactFileDialog.dialogID">
      <CRMWhatsappContactFileDialog
        :ref="`CRMWhatsappContactFileDialog_${CRMWhatsappContactFileDialog.dialogID}`"
        @closeCRMWhatsappContactFileDialog="closeDialog('CRMWhatsappContactFileDialog', CRMWhatsappContactFileDialog.dialogID)"
      ></CRMWhatsappContactFileDialog>
    </div>

    <div v-for="CRMWhatsappConversationHistoryDialog in navigation.CRMWhatsappConversationHistoryDialog" :key="CRMWhatsappConversationHistoryDialog.dialogID">
      <CRMWhatsappConversationHistoryDialog
        :ref="`CRMWhatsappConversationHistoryDialog_${CRMWhatsappConversationHistoryDialog.dialogID}`"
        @closeCRMWhatsappConversationHistoryDialog="closeDialog('CRMWhatsappConversationHistoryDialog', CRMWhatsappConversationHistoryDialog.dialogID)"
      ></CRMWhatsappConversationHistoryDialog>
    </div>
    
    <div v-for="CRMWhatsappProductFollowupHistoryDialog in navigation.CRMWhatsappProductFollowupHistoryDialog" :key="CRMWhatsappProductFollowupHistoryDialog.dialogID">
      <CRMWhatsappProductFollowupHistoryDialog
        :ref="`CRMWhatsappProductFollowupHistoryDialog_${CRMWhatsappProductFollowupHistoryDialog.dialogID}`"
        @closeCRMWhatsappProductFollowupHistoryDialog="closeDialog('CRMWhatsappProductFollowupHistoryDialog', CRMWhatsappProductFollowupHistoryDialog.dialogID)"
      ></CRMWhatsappProductFollowupHistoryDialog>
    </div>
    <div v-for="CRMWhatsappProductFollowupDialog in navigation.CRMWhatsappProductFollowupDialog" :key="CRMWhatsappProductFollowupDialog.dialogID">
      <CRMWhatsappProductFollowupDialog
        :ref="`CRMWhatsappProductFollowupDialog_${CRMWhatsappProductFollowupDialog.dialogID}`"
        @closeCRMWhatsappProductFollowupDialog="closeDialog('CRMWhatsappProductFollowupDialog', CRMWhatsappProductFollowupDialog.dialogID)"
      ></CRMWhatsappProductFollowupDialog>
    </div>




    <div v-for="SINPEPaymentDialog in navigation.SINPEPaymentDialog" :key="SINPEPaymentDialog.dialogID">
      <SINPEPaymentDialog
        :ref="`SINPEPaymentDialog_${SINPEPaymentDialog.dialogID}`"
        @closeSINPEPaymentDialog="closeDialog('SINPEPaymentDialog', SINPEPaymentDialog.dialogID)"
      ></SINPEPaymentDialog>
    </div>



    <div v-for="resumeCRMWhatsappConversationDialog in navigation.resumeCRMWhatsappConversationDialog" :key="resumeCRMWhatsappConversationDialog.dialogID">
      <resumeCRMWhatsappConversationDialog
        :ref="`resumeCRMWhatsappConversationDialog_${resumeCRMWhatsappConversationDialog.dialogID}`"
        @closeResumeCRMWhatsappConversationDialog="closeDialog('resumeCRMWhatsappConversationDialog', resumeCRMWhatsappConversationDialog.dialogID)"
      ></resumeCRMWhatsappConversationDialog>
    </div>
  </div>
</template>

<script>
  // CRMAgentDialogs
  import CRMAgentStickerDialog from './dialogs/CRMAgentDialogs/CRMAgentStickerDialog.vue';


  // CRMWhatsappContactDialogs
  import CRMWhatsappContactAddressDialog from './dialogs/CRMWhatsappContactDialogs/CRMWhatsappContactAddressDialog.vue';
  import CRMWhatsappContactDialog from './dialogs/CRMWhatsappContactDialogs/CRMWhatsappContactDialog.vue';
  import CRMWhatsappContactFileDialog from './dialogs/CRMWhatsappContactDialogs/CRMWhatsappContactFileDialog.vue';
  import CRMWhatsappContactFilesDialog from './dialogs/CRMWhatsappContactDialogs/CRMWhatsappContactFilesDialog.vue';
  import CRMWhatsappProductFollowupHistoryDialog from './CRMWhatsappProductFollowupHistoryDialog.vue';
  import CRMWhatsappProductFollowupDialog from './CRMWhatsappProductFollowupDialog.vue';
  import CRMWhatsappContactLatitudeLongitudeLocationDialog from './dialogs/CRMWhatsappContactDialogs/CRMWhatsappContactLatitudeLongitudeLocationDialog.vue';
  import CRMWhatsappContactLocationDialog from './dialogs/CRMWhatsappContactDialogs/CRMWhatsappContactLocationDialog.vue';
  import CRMWhatsappContactURLLocationDialog from './dialogs/CRMWhatsappContactDialogs/CRMWhatsappContactURLLocationDialog.vue';


  // CRMWhatsappConversationDialogs
  import closeCRMWhatsappConversationDialog from './dialogs/CRMWhatsappConversationDialogs/closeCRMWhatsappConversationDialog.vue';
  import CRMWhatsappConversationDialog from './dialogs/CRMWhatsappConversationDialogs/CRMWhatsappConversationDialog.vue';
  import CRMWhatsappConversationHistoryDialog from './dialogs/CRMWhatsappConversationDialogs/CRMWhatsappConversationHistoryDialog.vue';
  import CRMWhatsappConversationNoteDialog from './dialogs/CRMWhatsappConversationDialogs/CRMWhatsappConversationNoteDialog.vue';
  import insertCRMWhatsappConversationDialog from './dialogs/CRMWhatsappConversationDialogs/insertCRMWhatsappConversationDialog.vue';
  import rejectCRMWhatsappConversationDialog from './dialogs/CRMWhatsappConversationDialogs/rejectCRMWhatsappConversationDialog.vue';
  import resumeCRMWhatsappConversationDialog from './dialogs/CRMWhatsappConversationDialogs/resumeCRMWhatsappConversationDialog.vue';
  import sendCRMWhatsappMessageToCRMWhatsappContactDialog from './dialogs/CRMWhatsappConversationDialogs/sendCRMWhatsappMessageToCRMWhatsappContactDialog.vue';

  
  // CRMWhatsappInvoiceDialogs
  import CRMWhatsappInvoiceDialog from './dialogs/CRMWhatsappInvoiceDialogs/CRMWhatsappInvoiceDialog.vue';
  import CRMWhatsappInvoicesDialog from './dialogs/CRMWhatsappInvoiceDialogs/CRMWhatsappInvoicesDialog.vue';
  import SINPEPaymentDialog from './dialogs/CRMWhatsappInvoiceDialogs/SINPEPaymentDialog.vue';

  
  
  
  
  import MediaDialog from './dialogs/MediaDialog.vue';
  import CRMShutdownDialog from './dialogs/CRMShutdownDialog.vue';

  
  import CRMWhatsappMarketingCampaignDialog from '@/views/CRMWhatsappMarketingCampaingsView/dialogs/CRMWhatsappMarketingCampaignDialog.vue';
  import CRMWhatsappMediaCatalogDialog from '@/views/CRMWhatsappMediaCatalogsView/dialogs/CRMWhatsappMediaCatalogDialog.vue';
  import CRMWhatsappMediaCatalogMediaDialog from '@/views/CRMWhatsappMediaCatalogsView/dialogs/CRMWhatsappMediaCatalogMediaDialog.vue';
  
  
  
  

  export default {
    name: 'DialogComponent',
    components: 
    {
      CRMWhatsappContactDialog,
      CRMWhatsappContactLocationDialog,
      CRMWhatsappInvoiceDialog,
      CRMWhatsappInvoicesDialog,
      
      
      
      MediaDialog,
      CRMShutdownDialog,


      CRMWhatsappContactLatitudeLongitudeLocationDialog,
      CRMWhatsappContactURLLocationDialog,
      CRMWhatsappContactAddressDialog,
      
      CRMWhatsappMarketingCampaignDialog,
      CRMWhatsappMediaCatalogDialog,
      CRMWhatsappMediaCatalogMediaDialog,
      CRMWhatsappConversationDialog,
      
      CRMAgentStickerDialog,
      insertCRMWhatsappConversationDialog,
      closeCRMWhatsappConversationDialog,
      rejectCRMWhatsappConversationDialog,
      sendCRMWhatsappMessageToCRMWhatsappContactDialog,
      CRMWhatsappConversationNoteDialog,
      CRMWhatsappConversationHistoryDialog,
      CRMWhatsappProductFollowupHistoryDialog,
      CRMWhatsappProductFollowupDialog,
      CRMWhatsappContactFilesDialog,
      CRMWhatsappContactFileDialog,
      SINPEPaymentDialog,
      resumeCRMWhatsappConversationDialog
    },

    data: () => ({
      navigation: 
      {
        CRMWhatsappContactDialog: [],
        CRMWhatsappContactLocationDialog: [],
        CRMWhatsappInvoiceDialog: [],
        CRMWhatsappInvoicesDialog: [],
        
        
        
        MediaDialog: [],

        CRMShutdownDialog: [],


        CRMWhatsappContactLatitudeLongitudeLocationDialog: [],
        CRMWhatsappContactURLLocationDialog: [],
        CRMWhatsappContactAddressDialog: [],
        
        CRMWhatsappMarketingCampaignDialog: [],
        CRMWhatsappMediaCatalogDialog: [],
        CRMWhatsappMediaCatalogMediaDialog: [],
        CRMWhatsappConversationDialog: [],
        
        CRMAgentStickerDialog: [],
        insertCRMWhatsappConversationDialog: [],
        closeCRMWhatsappConversationDialog: [],
        rejectCRMWhatsappConversationDialog: [],
        CRMWhatsappConversationNoteDialog: [],
        CRMWhatsappConversationHistoryDialog: [],
        CRMWhatsappProductFollowupHistoryDialog: [],
        CRMWhatsappProductFollowupDialog: [],
        sendCRMWhatsappMessageToCRMWhatsappContactDialog: [],
        CRMWhatsappContactFilesDialog: [],
        CRMWhatsappContactFileDialog: [],
        SINPEPaymentDialog: [],
        resumeCRMWhatsappConversationDialog: []
      }
    }),

    methods: 
    {

      openCRMWhatsappContactDialog(CRMWhatsappContactID, action) {
        const CRMWhatsappContactDialog = {'dialogID': `CRMWhatsappContactDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMWhatsappContactDialog.push(CRMWhatsappContactDialog);
        this.$nextTick(() => {
          const CRMWhatsappContactDialogReference = this.$refs[`CRMWhatsappContactDialog_${CRMWhatsappContactDialog.dialogID}`];
          if (CRMWhatsappContactDialogReference && CRMWhatsappContactDialogReference[0]) {
            CRMWhatsappContactDialogReference[0].openCRMWhatsappContactDialog(CRMWhatsappContactID, action);
          }
        });
      },
      openCRMWhatsappContactLocationDialog(CRMWhatsappContactID) {
        const CRMWhatsappContactLocationDialog = {'dialogID': `CRMWhatsappContactLocationDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMWhatsappContactLocationDialog.push(CRMWhatsappContactLocationDialog);
        this.$nextTick(() => {
          const CRMWhatsappContactLocationDialogReference = this.$refs[`CRMWhatsappContactLocationDialog_${CRMWhatsappContactLocationDialog.dialogID}`];
          if (CRMWhatsappContactLocationDialogReference && CRMWhatsappContactLocationDialogReference[0]) {
            CRMWhatsappContactLocationDialogReference[0].openCRMWhatsappContactLocationDialog(CRMWhatsappContactID);
          }
        });
      },
      openCRMWhatsappInvoiceDialog(CRMWhatsappInvoiceID) {
        const CRMWhatsappInvoiceDialog = {'dialogID': `CRMWhatsappInvoiceDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMWhatsappInvoiceDialog.push(CRMWhatsappInvoiceDialog);
        this.$nextTick(() => {
          const CRMWhatsappInvoiceDialogReference = this.$refs[`CRMWhatsappInvoiceDialog_${CRMWhatsappInvoiceDialog.dialogID}`];
          if (CRMWhatsappInvoiceDialogReference && CRMWhatsappInvoiceDialogReference[0]) {
            CRMWhatsappInvoiceDialogReference[0].openCRMWhatsappInvoiceDialog(CRMWhatsappInvoiceID);
          }
        });
      },
      openCRMWhatsappInvoicesDialog(date, CRMAgentID, newCRMWhatsappContact, productCategoryID, CRMWhatsappInvoiceCreationHour, CRMWhatsappInvoiceCRMLocalityID, CRMWhatsappInvoiceCRMLocalityMapDivisionID, CRMWhatsappInvoiceShippingCRMAgentID, isCRMWhatsappContactFollowup) {
        const CRMWhatsappInvoicesDialog = {'dialogID': `CRMWhatsappInvoicesDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMWhatsappInvoicesDialog.push(CRMWhatsappInvoicesDialog);
        this.$nextTick(() => {
          const CRMWhatsappInvoicesDialogReference = this.$refs[`CRMWhatsappInvoicesDialog_${CRMWhatsappInvoicesDialog.dialogID}`];
          if (CRMWhatsappInvoicesDialogReference && CRMWhatsappInvoicesDialogReference[0]) {
            CRMWhatsappInvoicesDialogReference[0].openCRMWhatsappInvoicesDialog(date, CRMAgentID, newCRMWhatsappContact, productCategoryID, CRMWhatsappInvoiceCreationHour, CRMWhatsappInvoiceCRMLocalityID, CRMWhatsappInvoiceCRMLocalityMapDivisionID, CRMWhatsappInvoiceShippingCRMAgentID, isCRMWhatsappContactFollowup);
          }
        });
      },





      openMediaDialog(mediaURL, mediaName, mediaExtension) {
        const MediaDialog = {'dialogID': `MediaDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.MediaDialog.push(MediaDialog);
        this.$nextTick(() => {
          const MediaDialogReference = this.$refs[`MediaDialog_${MediaDialog.dialogID}`];
          if (MediaDialogReference && MediaDialogReference[0]) {
            MediaDialogReference[0].openMediaDialog(mediaURL, mediaName, mediaExtension);
          }
        });
      },

      openCRMShutdownDialog() {
        const CRMShutdownDialog = {'dialogID': `CRMShutdownDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMShutdownDialog.push(CRMShutdownDialog);
        this.$nextTick(() => {
          const CRMShutdownDialogReference = this.$refs[`CRMShutdownDialog_${CRMShutdownDialog.dialogID}`];
          if (CRMShutdownDialogReference && CRMShutdownDialogReference[0]) {
            CRMShutdownDialogReference[0].openCRMShutdownDialog();
          }
        });
      },


      openCRMWhatsappContactLatitudeLongitudeLocationDialog(CRMWhatsappContactID, CRMWhatsappContactLatitudeLongitudeLocationID, CRMWhatsappContactLatitudeLongitudeLocationLatitude, CRMWhatsappContactLatitudeLongitudeLocationLongitude, CRMWhatsappContactLatitudeLongitudeLocationDialogAction) {
        const CRMWhatsappContactLatitudeLongitudeLocationDialog = {'dialogID': `CRMWhatsappContactLatitudeLongitudeLocationDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMWhatsappContactLatitudeLongitudeLocationDialog.push(CRMWhatsappContactLatitudeLongitudeLocationDialog);
        this.$nextTick(() => {
          const CRMWhatsappContactLatitudeLongitudeLocationDialogReference = this.$refs[`CRMWhatsappContactLatitudeLongitudeLocationDialog_${CRMWhatsappContactLatitudeLongitudeLocationDialog.dialogID}`];
          if (CRMWhatsappContactLatitudeLongitudeLocationDialogReference && CRMWhatsappContactLatitudeLongitudeLocationDialogReference[0]) {
            CRMWhatsappContactLatitudeLongitudeLocationDialogReference[0].openCRMWhatsappContactLatitudeLongitudeLocationDialog(CRMWhatsappContactID, CRMWhatsappContactLatitudeLongitudeLocationID, CRMWhatsappContactLatitudeLongitudeLocationLatitude, CRMWhatsappContactLatitudeLongitudeLocationLongitude, CRMWhatsappContactLatitudeLongitudeLocationDialogAction);
          }
        });
      },
      openCRMWhatsappContactURLLocationDialog(CRMWhatsappContactID, CRMWhatsappContactURLLocationID, CRMWhatsappContactURLLocationDialogAction) {
        const CRMWhatsappContactURLLocationDialog = {'dialogID': `CRMWhatsappContactURLLocationDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMWhatsappContactURLLocationDialog.push(CRMWhatsappContactURLLocationDialog);
        this.$nextTick(() => {
          const CRMWhatsappContactURLLocationDialogReference = this.$refs[`CRMWhatsappContactURLLocationDialog_${CRMWhatsappContactURLLocationDialog.dialogID}`];
          if (CRMWhatsappContactURLLocationDialogReference && CRMWhatsappContactURLLocationDialogReference[0]) {
            CRMWhatsappContactURLLocationDialogReference[0].openCRMWhatsappContactURLLocationDialog(CRMWhatsappContactID, CRMWhatsappContactURLLocationID, CRMWhatsappContactURLLocationDialogAction);
          }
        });
      },
      openCRMWhatsappContactAddressDialog(CRMWhatsappContactID, CRMWhatsappContactAddressID, CRMWhatsappContactAddressDialogAction) {
        const CRMWhatsappContactAddressDialog = {'dialogID': `CRMWhatsappContactAddressDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMWhatsappContactAddressDialog.push(CRMWhatsappContactAddressDialog);
        this.$nextTick(() => {
          const CRMWhatsappContactAddressDialogReference = this.$refs[`CRMWhatsappContactAddressDialog_${CRMWhatsappContactAddressDialog.dialogID}`];
          if (CRMWhatsappContactAddressDialogReference && CRMWhatsappContactAddressDialogReference[0]) {
            CRMWhatsappContactAddressDialogReference[0].openCRMWhatsappContactAddressDialog(CRMWhatsappContactID, CRMWhatsappContactAddressID, CRMWhatsappContactAddressDialogAction);
          }
        });
      },



      openCRMWhatsappMarketingCampaignDialog(action, callbackFunction, CRMWhatsappMarketingCampaignID) {
        const CRMWhatsappMarketingCampaignDialog = {'dialogID': `CRMWhatsappMarketingCampaignDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMWhatsappMarketingCampaignDialog.push(CRMWhatsappMarketingCampaignDialog);
        this.$nextTick(() => {
          const CRMWhatsappMarketingCampaignDialogReference = this.$refs[`CRMWhatsappMarketingCampaignDialog_${CRMWhatsappMarketingCampaignDialog.dialogID}`];
          if (CRMWhatsappMarketingCampaignDialogReference && CRMWhatsappMarketingCampaignDialogReference[0]) {
            CRMWhatsappMarketingCampaignDialogReference[0].openCRMWhatsappMarketingCampaignDialog(action, callbackFunction, CRMWhatsappMarketingCampaignID);
          }
        });
      },
      openCRMWhatsappMediaCatalogDialog(CRMWhatsappMediaCatalog, insertCRMWhatsappMediaCatalog, updateCRMWhatsappMediaCatalog, deleteCRMWhatsappMediaCatalog) {
        const CRMWhatsappMediaCatalogDialog = {'dialogID': `CRMWhatsappMediaCatalogDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMWhatsappMediaCatalogDialog.push(CRMWhatsappMediaCatalogDialog);
        this.$nextTick(() => {
          const CRMWhatsappMediaCatalogDialogReference = this.$refs[`CRMWhatsappMediaCatalogDialog_${CRMWhatsappMediaCatalogDialog.dialogID}`];
          if (CRMWhatsappMediaCatalogDialogReference && CRMWhatsappMediaCatalogDialogReference[0]) {
            CRMWhatsappMediaCatalogDialogReference[0].openCRMWhatsappMediaCatalogDialog(CRMWhatsappMediaCatalog, insertCRMWhatsappMediaCatalog, updateCRMWhatsappMediaCatalog, deleteCRMWhatsappMediaCatalog);
          }
        });
      },
      openCRMWhatsappMediaCatalogMediaDialog(CRMWhatsappMediaCatalog, CRMWhatsappMediaCatalogMedia, insertCRMWhatsappMediaCatalogMedia, updateCRMWhatsappMediaCatalogMedia, deleteCRMWhatsappMediaCatalogMedia) {
        const CRMWhatsappMediaCatalogMediaDialog = {'dialogID': `CRMWhatsappMediaCatalogMediaDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMWhatsappMediaCatalogMediaDialog.push(CRMWhatsappMediaCatalogMediaDialog);
        this.$nextTick(() => {
          const CRMWhatsappMediaCatalogMediaDialogReference = this.$refs[`CRMWhatsappMediaCatalogMediaDialog_${CRMWhatsappMediaCatalogMediaDialog.dialogID}`];
          if (CRMWhatsappMediaCatalogMediaDialogReference && CRMWhatsappMediaCatalogMediaDialogReference[0]) {
            CRMWhatsappMediaCatalogMediaDialogReference[0].openCRMWhatsappMediaCatalogMediaDialog(CRMWhatsappMediaCatalog, CRMWhatsappMediaCatalogMedia, insertCRMWhatsappMediaCatalogMedia, updateCRMWhatsappMediaCatalogMedia, deleteCRMWhatsappMediaCatalogMedia);
          }
        });
      },
      openCRMWhatsappConversationDialog(CRMWhatsappConversationID, CRMWhatsappConversationCurrentCRMAgentIsVisible, updateCRMWhatsappConversationIsPinnedIsActive, CRMWhatsappConversationAssistanceIsActive, CRMWhatsappConversationNoteIsActive, CRMWhatsappConversationHistoryIsActive, CRMWhatsappContactFollowupHistoryIsActive, transferCRMWhatsappConversationIsActive, closeCRMWhatsappConversationIsActive, rejectCRMWhatsappConversationIsActive, AIAssistantIsActive, CRMWhatsappMessageIsActive, openInFullScreen) {
        const CRMWhatsappConversationDialog = {'dialogID': `CRMWhatsappConversationDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMWhatsappConversationDialog.push(CRMWhatsappConversationDialog);
        this.$nextTick(() => {
          const CRMWhatsappConversationDialogReference = this.$refs[`CRMWhatsappConversationDialog_${CRMWhatsappConversationDialog.dialogID}`];
          if (CRMWhatsappConversationDialogReference && CRMWhatsappConversationDialogReference[0]) {
            CRMWhatsappConversationDialogReference[0].openCRMWhatsappConversationDialog(CRMWhatsappConversationID, CRMWhatsappConversationCurrentCRMAgentIsVisible, updateCRMWhatsappConversationIsPinnedIsActive, CRMWhatsappConversationAssistanceIsActive, CRMWhatsappConversationNoteIsActive, CRMWhatsappConversationHistoryIsActive, CRMWhatsappContactFollowupHistoryIsActive, transferCRMWhatsappConversationIsActive, closeCRMWhatsappConversationIsActive, rejectCRMWhatsappConversationIsActive, AIAssistantIsActive, CRMWhatsappMessageIsActive, openInFullScreen);
          }
        });
      },




      openCRMAgentStickerDialog(insertCRMAgentSticker, updateCRMAgentSticker, deleteCRMAgentSticker, CRMAgentSticker) {
        const CRMAgentStickerDialog = {'dialogID': `CRMAgentStickerDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMAgentStickerDialog.push(CRMAgentStickerDialog);
        this.$nextTick(() => {
          const CRMAgentStickerDialogReference = this.$refs[`CRMAgentStickerDialog_${CRMAgentStickerDialog.dialogID}`];
          if (CRMAgentStickerDialogReference && CRMAgentStickerDialogReference[0]) {
            CRMAgentStickerDialogReference[0].openCRMAgentStickerDialog(insertCRMAgentSticker, updateCRMAgentSticker, deleteCRMAgentSticker, CRMAgentSticker);
          }
        });
      },
      openInsertCRMWhatsappConversationDialog() { 
        const insertCRMWhatsappConversationDialog = {'dialogID': `insertCRMWhatsappConversationDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.insertCRMWhatsappConversationDialog.push(insertCRMWhatsappConversationDialog);
        this.$nextTick(() => {
          const insertCRMWhatsappConversationDialogReference = this.$refs[`insertCRMWhatsappConversationDialog_${insertCRMWhatsappConversationDialog.dialogID}`];
          if (insertCRMWhatsappConversationDialogReference && insertCRMWhatsappConversationDialogReference[0]) {
            insertCRMWhatsappConversationDialogReference[0].openInsertCRMWhatsappConversationDialog();
          }
        });
      },
      openCloseCRMWhatsappConversationDialog(CRMWhatsappConversationID, CRMWhatsappContactID) {
        const closeCRMWhatsappConversationDialog = {'dialogID': `closeCRMWhatsappConversationDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.closeCRMWhatsappConversationDialog.push(closeCRMWhatsappConversationDialog);
        this.$nextTick(() => {
          const closeCRMWhatsappConversationDialogReference = this.$refs[`closeCRMWhatsappConversationDialog_${closeCRMWhatsappConversationDialog.dialogID}`];
          if (closeCRMWhatsappConversationDialogReference && closeCRMWhatsappConversationDialogReference[0]) {
            closeCRMWhatsappConversationDialogReference[0].openCloseCRMWhatsappConversationDialog(CRMWhatsappConversationID, CRMWhatsappContactID);
          }
        });
      },
      openRejectCRMWhatsappConversationDialog(CRMWhatsappConversation) {
        const rejectCRMWhatsappConversationDialog = {'dialogID': `rejectCRMWhatsappConversationDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.rejectCRMWhatsappConversationDialog.push(rejectCRMWhatsappConversationDialog);
        this.$nextTick(() => {
          const rejectCRMWhatsappConversationDialogReference = this.$refs[`rejectCRMWhatsappConversationDialog_${rejectCRMWhatsappConversationDialog.dialogID}`];
          if (rejectCRMWhatsappConversationDialogReference && rejectCRMWhatsappConversationDialogReference[0]) {
            rejectCRMWhatsappConversationDialogReference[0].openRejectCRMWhatsappConversationDialog(CRMWhatsappConversation);
          }
        });
      },
      openCRMWhatsappConversationHistoryDialog(CRMWhatsappContactID) {
        const CRMWhatsappConversationHistoryDialog = {'dialogID': `CRMWhatsappConversationHistoryDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMWhatsappConversationHistoryDialog.push(CRMWhatsappConversationHistoryDialog);
        this.$nextTick(() => {
          const CRMWhatsappConversationHistoryDialogReference = this.$refs[`CRMWhatsappConversationHistoryDialog_${CRMWhatsappConversationHistoryDialog.dialogID}`];
          if (CRMWhatsappConversationHistoryDialogReference && CRMWhatsappConversationHistoryDialogReference[0]) {
            CRMWhatsappConversationHistoryDialogReference[0].openCRMWhatsappConversationHistoryDialog(CRMWhatsappContactID);
          }
        });
      },
      openCRMWhatsappConversationNoteDialog(CRMWhatsappContactID, CRMWhatsappConversationID, CRMWhatsappConversationNotePriority) {        
        const CRMWhatsappConversationNoteDialog = {'dialogID': `CRMWhatsappConversationNoteDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMWhatsappConversationNoteDialog.push(CRMWhatsappConversationNoteDialog);
        this.$nextTick(() => {
          const CRMWhatsappConversationNoteDialogReference = this.$refs[`CRMWhatsappConversationNoteDialog_${CRMWhatsappConversationNoteDialog.dialogID}`];
          if (CRMWhatsappConversationNoteDialogReference && CRMWhatsappConversationNoteDialogReference[0]) {
            CRMWhatsappConversationNoteDialogReference[0].openCRMWhatsappConversationNoteDialog(CRMWhatsappContactID, CRMWhatsappConversationID, CRMWhatsappConversationNotePriority);
          }
        });
      },

      openCRMWhatsappProductFollowupHistoryDialog(CRMWhatsappContactID, CRMWhatsappConversationID) {
        const CRMWhatsappProductFollowupHistoryDialog = {'dialogID': `CRMWhatsappProductFollowupHistoryDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMWhatsappProductFollowupHistoryDialog.push(CRMWhatsappProductFollowupHistoryDialog);
        this.$nextTick(() => {
          const CRMWhatsappProductFollowupHistoryDialogReference = this.$refs[`CRMWhatsappProductFollowupHistoryDialog_${CRMWhatsappProductFollowupHistoryDialog.dialogID}`];
          if (CRMWhatsappProductFollowupHistoryDialogReference && CRMWhatsappProductFollowupHistoryDialogReference[0]) {
            CRMWhatsappProductFollowupHistoryDialogReference[0].openCRMWhatsappProductFollowupHistoryDialog(CRMWhatsappContactID, CRMWhatsappConversationID);
          }
        });
      },
      openCRMWhatsappProductFollowupDialog(action, CRMWhatsappContactID, CRMWhatsappProductFollowupID, CRMWhatsappConversationID, callbackFunction) {
        const CRMWhatsappProductFollowupDialog = {'dialogID': `CRMWhatsappProductFollowupDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMWhatsappProductFollowupDialog.push(CRMWhatsappProductFollowupDialog);
        this.$nextTick(() => {
          const CRMWhatsappProductFollowupDialogReference = this.$refs[`CRMWhatsappProductFollowupDialog_${CRMWhatsappProductFollowupDialog.dialogID}`];
          if (CRMWhatsappProductFollowupDialogReference && CRMWhatsappProductFollowupDialogReference[0]) {
            CRMWhatsappProductFollowupDialogReference[0].openCRMWhatsappProductFollowupDialog(action, CRMWhatsappContactID, CRMWhatsappProductFollowupID, CRMWhatsappConversationID, callbackFunction);
          }
        });
      },


      openSendCRMWhatsappMessageToCRMWhatsappContactDialog(CRMWhatsappContactID, generateCRMWhatsappContactFollowup) {
        const sendCRMWhatsappMessageToCRMWhatsappContactDialog = {'dialogID': `sendCRMWhatsappMessageToCRMWhatsappContactDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.sendCRMWhatsappMessageToCRMWhatsappContactDialog.push(sendCRMWhatsappMessageToCRMWhatsappContactDialog);
        this.$nextTick(() => {
          const sendCRMWhatsappMessageToCRMWhatsappContactDialogReference = this.$refs[`sendCRMWhatsappMessageToCRMWhatsappContactDialog_${sendCRMWhatsappMessageToCRMWhatsappContactDialog.dialogID}`];
          if (sendCRMWhatsappMessageToCRMWhatsappContactDialogReference && sendCRMWhatsappMessageToCRMWhatsappContactDialogReference[0]) {
            sendCRMWhatsappMessageToCRMWhatsappContactDialogReference[0].openSendCRMWhatsappMessageToCRMWhatsappContactDialog(CRMWhatsappContactID, generateCRMWhatsappContactFollowup);
          }
        });
      },
      openCRMWhatsappContactFilesDialog(CRMWhatsappContactID) {
        const CRMWhatsappContactFilesDialog = {'dialogID': `CRMWhatsappContactFilesDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMWhatsappContactFilesDialog.push(CRMWhatsappContactFilesDialog);
        this.$nextTick(() => {
          const CRMWhatsappContactFilesDialogReference = this.$refs[`CRMWhatsappContactFilesDialog_${CRMWhatsappContactFilesDialog.dialogID}`];
          if (CRMWhatsappContactFilesDialogReference && CRMWhatsappContactFilesDialogReference[0]) {
            CRMWhatsappContactFilesDialogReference[0].openCRMWhatsappContactFilesDialog(CRMWhatsappContactID);
          }
        });
      },
      openCRMWhatsappContactFileDialog(CRMWhatsappContactID, CRMWhatsappContactFile, CRMWhatsappContactFileDialogAction) {
        const CRMWhatsappContactFileDialog = {'dialogID': `CRMWhatsappContactFileDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.CRMWhatsappContactFileDialog.push(CRMWhatsappContactFileDialog);
        this.$nextTick(() => {
          const CRMWhatsappContactFileDialogReference = this.$refs[`CRMWhatsappContactFileDialog_${CRMWhatsappContactFileDialog.dialogID}`];
          if (CRMWhatsappContactFileDialogReference && CRMWhatsappContactFileDialogReference[0]) {
            CRMWhatsappContactFileDialogReference[0].openCRMWhatsappContactFileDialog(CRMWhatsappContactID, CRMWhatsappContactFile, CRMWhatsappContactFileDialogAction);
          }
        });
      },
      openSINPEPaymentDialog(CRMWhatsappConversationID, CRMWhatsappInvoiceID, amount) {
        const SINPEPaymentDialog = {'dialogID': `SINPEPaymentDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.SINPEPaymentDialog.push(SINPEPaymentDialog);
        this.$nextTick(() => {
          const SINPEPaymentDialogReference = this.$refs[`SINPEPaymentDialog_${SINPEPaymentDialog.dialogID}`];
          if (SINPEPaymentDialogReference && SINPEPaymentDialogReference[0]) {
            SINPEPaymentDialogReference[0].openSINPEPaymentDialog(CRMWhatsappConversationID, CRMWhatsappInvoiceID, amount);
          }
        });
      },

      openResumeCRMWhatsappConversationDialog(CRMWhatsappConversationID) {
        const resumeCRMWhatsappConversationDialog = {'dialogID': `resumeCRMWhatsappConversationDialog_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`};
        this.navigation.resumeCRMWhatsappConversationDialog.push(resumeCRMWhatsappConversationDialog);
        this.$nextTick(() => {
          const resumeCRMWhatsappConversationDialogReference = this.$refs[`resumeCRMWhatsappConversationDialog_${resumeCRMWhatsappConversationDialog.dialogID}`];
          if (resumeCRMWhatsappConversationDialogReference && resumeCRMWhatsappConversationDialogReference[0]) {
            resumeCRMWhatsappConversationDialogReference[0].openResumeCRMWhatsappConversationDialog(CRMWhatsappConversationID);
          }
        });
      },

     

      closeDialog(dialogType, dialogID) {
        const dialogIndex = this.navigation[dialogType].findIndex(dialog => dialog.dialogID == dialogID);
        if (dialogIndex != -1) {
          setTimeout(() => {
            this.navigation[dialogType].splice(dialogIndex, 1);
          }, 1000);
        }
      }
    },

    mounted() {}
  }
</script> 